export { default } from './Paper';